<template>
  <div class="tabs_content" id="tab-2" v-if="this.loaded">
    <section>
        <a :data-title="$gettext('Přenačíst kanály')" class="tab_button tab_button_refresh title_tooltip" @click.stop="getEntities" />

    <div class="left">
      <h2 v-if="this.loaded && radioItems.length === 0 && tvItems.length === 0" v-translate>Neexistují žádné kanály pro toto zařízení</h2>
      <h2 v-else v-translate>Kanály pro toto zařízení</h2>
    </div>
      <div class="right checkbox_group">
        <div v-if="tvItems.length > 0">
          <h2 class="checkbox_group_label" v-translate>TV KANÁLY</h2>
          <ul>
            <li v-for="channel in tvItems" :key="channel.id">
              <label :class="{deleted: restrictedChannels.includes(channel.id)}">
                <entity-link :id="channel.id" type="channel">{{ channel.name }}</entity-link> <span v-if="channel.hd" class="stitek">HD</span>
              </label>
            </li>
          </ul>
        </div>
        <div v-if="radioItems.length > 0">
          <h2 class="checkbox_group_label" v-translate>RÁDIA</h2>
          <ul>
            <li
                v-for="channel in radioItems"
                :key="channel.id"
            >
              <label :class="{deleted: restrictedChannels.includes(channel.id)}">
                <entity-link :id="channel.id" type="channel">{{ channel.name }}</entity-link> <span v-if="channel.hd" class="stitek">HD</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import detailActions from "@/components/mixins/detail-actions"
import EntityLink from "../../../common/EntityLink.vue";

export default {
  name: "DeviceChannels",
  components: { EntityLink },
  mixins: [
    detailActions
  ],
  data() {
    return {
      channels: [],
      restrictedChannels: [],
      loaded: false
    }
  },
  created(DeviceService) {
    this.deviceService = DeviceService
    this.getEntities()
  },
  methods: {
    getEntities() {
      this.channels = [];
      this.loaded = false;
      this.setLoadingMessage()
      return this.deviceService.getChannels(this.$route.params.id)
          .then(data => {
            this.emptyMessage()
            this.channels = data['channels']
            this.restrictedChannels = data['restricted_channels']
            this.loaded = true;
          })
          .catch(function (error) {
            this.setErrorMessage(error['error_message'])
            this.loaded = true;
          }.bind(this, console))
    },
  },
  computed: {
    tvItems() {
      return this._.filter(this.channels, (item) => {
        return Number(item.id_type) === 1
      })
    },
    radioItems() {
      return this._.filter(this.channels, (item) => {
        return Number(item.id_type) === 2
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/Channels.vue